export enum EQuestionType {
  SECTION = 'section',
  HEADER = 'header',
}
